export default __webpack_public_path__ + "static/blob2-156f38631ab3585255013c2a1f120d94.svg";